import { useState } from 'react';
import './App.css';
import About from './Components/About';
import Contact from './Components/Contact';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from './Components/Hero';
import Why from './Components/why';
import Gallery from './Components/Gallary';
import Products from './Components/Products';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const pages = {
    home: <Home />,
    about: <About />,
    products: <Products />,
    gallery: <Gallery />,
    why: <Why />,
    contact: <Contact />,
    
  };

  return (
    <div className="App">
      <Navbar setCurrentPage={setCurrentPage} currentPage={currentPage} />
      <main className="main-content">
        {pages[currentPage as keyof typeof pages] || <Home />}
      </main>
      <About />
      <Products />
      <Gallery />
      <Why />
      <Contact />
      <Footer />

    </div>
  );
}

export default App;